import { createPortal } from 'react-dom'
import React from 'react'
import UserTypeChanges from '../index'

interface Params {
  id: string;
}

export default function UserTypeChangesPortal({ id }: Params) {
  const Root = document.getElementById(id);

  if (!Root) {
    return null
  }

  const userId = Root.getAttribute('data-userId');

  if (!userId) {
    throw new Error('"data-userId" attribute is required')
  }

  return createPortal(<UserTypeChanges userId={parseInt(userId, 10)} />, Root)
}
